import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

export function AddIncomeGroupDialog({ open, onClose, cfg, onSaved }) {
  const [name, setName] = useState("");
  const groups = cfg?.income_groups || [];

  const save = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await api.put("/finance/config", { ...cfg, income_groups: [...groups, { name: name.trim() }] });
      toast.success(`Income group "${name.trim()}" added`);
      setName("");
      onSaved();
      onClose();
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="add-income-group-dialog">
        <DialogHeader>
          <DialogTitle>Add income group</DialogTitle>
          <DialogDescription>It will be number {groups.length + 1} on the report. Put income lines into it in Admin Panel → Financial Report.</DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <Input autoFocus value={name} onChange={(e) => setName(e.target.value)} maxLength={120} placeholder="Group name" className="h-11 bg-white text-slate-900" data-testid="add-income-group-name" />
          <Button type="submit" disabled={!name.trim()} className="w-full" data-testid="add-income-group-save">Add group</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
